export default "__VITE_ASSET__c8f387a2__"